export default (state) => {
  state.currentAdministrator.submissionsReport.isFetching = false;
};
